import { useCallback, useState } from 'react';
import { JustRightHeightModal } from 'components/styled/scoped';
import { useTranslate } from '@tolgee/react';
import styled from '@emotion/styled';
import { css } from '@emotion/css';
import useSlide from 'views/Conversation/Sider/useSlide';
import SiderImageSlide from 'views/Conversation/Sider/SiderImageSlide';
import { PreviewModalProvider } from 'views/Conversation/Sider/PreviewModal';

type EvidenceModalProps = {
  visible: boolean;
  onCancel: () => void;
  meta: Meta;
};

function EvidenceModal(props: EvidenceModalProps) {
  const { visible, onCancel, meta } = props;
  const { t } = useTranslate();
  const { index: imageIndex } = useSlide({
    count: 3,
    length: meta?.info?.image?.length || 0,
    initialIndex: 0,
  });

  return (
    <JustRightHeightModal
      width={560}
      title={t('ViewRefund.checkEvidence')}
      visible={visible}
      onCancel={onCancel}
      footer={null}
      className={css`
        .ant-modal-body {
          padding-top: 15px;
          padding-bottom: 15px;
        }
      `}
    >
      <Container>
        <div className="title">
          <span className="name">{meta?.userName}</span>
          <span>{t('trade.上传证据')}</span>
          <span className="time">{meta?.operateTime}</span>
        </div>
        <ImageView>
          <PreviewModalProvider>
            <SiderImageSlide
              width={260}
              images={meta?.info?.image}
              count={3}
              index={imageIndex}
              offsetPercent={2}
            />
          </PreviewModalProvider>
        </ImageView>
        {meta?.info?.description && (
          <div className="desc">
            <div>{t('feedback.描述')}:</div>
            <div>
              <div>{meta?.info?.description}</div>
            </div>
          </div>
        )}
      </Container>
    </JustRightHeightModal>
  );
}

type Meta = {
  userName: string;
  operateTime: string;
  info: any;
};
function useEvidenceModal() {
  const [visible, setVisible] = useState(false);
  const [meta, setMeta] = useState({} as Meta);
  const open = useCallback((meta: Meta) => {
    setVisible(true);
    setMeta(meta);
  }, []);
  const close = useCallback(() => setVisible(false), []);
  const modal = visible && <EvidenceModal visible={visible} onCancel={close} meta={meta} />;
  return [open, modal] as const;
}

const Container = styled.div`
  .title {
    padding-left: 14px;
    font-size: 14px;
    line-height: 20px;
    color: var(--fett-text-secondary);
    position: relative;
    &:before {
      content: '';
      width: 8px;
      height: 8px;
      display: block;
      border-radius: 4px;
      background: #d3d7e0;
      position: absolute;
      left: 0;
      top: 8px;
    }
    .userName {
      margin-right: 6px;
    }
    .time {
      float: right;
    }
  }
  .desc {
    display: flex;
    & > div {
      &:nth-child(1) {
        flex-grow: 0;
        white-space: nowrap;
        line-height: 20px;
        margin-right: 4px;
      }
      &:nth-child(2) {
        flex-grow: 1;
        overflow: hidden;
        line-height: 20px;
        font-size: 14px;
        color: var(--fett-text-secondary);
        & > div {
        }
      }
    }
  }
`;

const ImageView = styled.div`
  margin-top: 5px;
  margin-bottom: 9px;
`;

export default useEvidenceModal;
